export default __webpack_public_path__ + "static/intercom-928f526f31e4174e0a73ce70d5ecb2db.svg";